import { Button, Group, Text } from '@mantine/core'
import GoogleIcon from '@legacy/common/Icons/Google'
import { useTranslation } from 'react-i18next'
import type { LinkedAccountsSectionProps } from '../types'
import { GoogleConnectButton } from './GoogleConnectButton'

/**
 * Displays linked external accounts with connect/disconnect actions.
 * Shows a single Google row with either a Connect or Disconnect action.
 */
export function LinkedAccountsSection({
  googleConnected,
  disconnecting,
  onDisconnect,
  onConnectSuccess,
  userEmail,
}: LinkedAccountsSectionProps) {
  const { t } = useTranslation()

  return (
    <div>
      <Text fw={600} size='lg' mb='md'>
        {t('my_profile.linked_accounts')}
      </Text>

      <Group spacing='sm'>
        <GoogleIcon />
        {googleConnected ? (
          <>
            <Text size='sm'>{t('my_profile.connected')}</Text>
            <Button
              variant='outline'
              color='red'
              size='sm'
              compact
              loading={disconnecting}
              onClick={onDisconnect}
            >
              {t('my_profile.disconnect')}
            </Button>
          </>
        ) : (
          <GoogleConnectButton userEmail={userEmail} onSuccess={onConnectSuccess} />
        )}
      </Group>
    </div>
  )
}
